import {
  APILibraryCategory,
  type APILibraryCategoryResponseType,
  type IAPILibraryCategory,
} from "@/core/data_sources/models/APILibraryCategory";
import { State } from "@/core/data_sources/store/state";

export type LibraryCategoriesStateType = {
  list: IAPILibraryCategory[];
};

export class LibraryCategoriesState extends State<LibraryCategoriesStateType> {
  constructor() {
    super({ list: [] });
  }

  setCategories(categories: APILibraryCategoryResponseType[]) {
    this._observable.next({
      list: categories.map((category) => new APILibraryCategory(category)),
    });
  }
  clear(): void {
    this._observable.next({ list: [] });
  }
}
